import { CampaignActionItemController } from './campaign-action-item.controller'

function campaignActionItem () {
  return {
    scope: {
      action: '<',
      campaignId: '<',
      index: '<',
      isSelected: '<',
      loading: '<'
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-action-item/campaign-action-item.html?$$REVISION$$',
    controller: CampaignActionItemController
  }
}

export { campaignActionItem }
